import { Injectable } from '@angular/core';

import { Itinerary, CarTypeData, AccomodationReservation, AccomodationReservationProposal, DayActivity, ItineraryActivityType, ItineraryActivityTypeData } from "./itineray.model";

@Injectable({
  providedIn: 'root'
})
export class ItineraryExpensesCalculatorService {

  constructor() { }

  calulate(itinerary: Itinerary) {

    itinerary.expenses = {
      min: {
        total: 0,
        items: []
      },
      max: {
        total: 0,
        items: []
      }
    };

    const addReservationsForTransportations = (label: string, icon: string, reservations: { price: number }[]) => {

      const rowMin = {
        label,
        icon,
        total: 0,
        items: []
      };

      const rowMax = {
        label,
        icon,
        total: 0,
        items: []
      };

      for (const reservation of reservations) {
        rowMin.total += reservation.price
        rowMin.items.push({
          label: null, //TODO
          value: reservation.price
        });
        rowMax.total += reservation.price;
        rowMax.items.push({
          label: null, //TODO
          value: reservation.price
        });
      }

      if (rowMin.total > 0 || rowMax.total > 0) {
        itinerary.expenses.max.items.push(rowMax);
        itinerary.expenses.min.items.push(rowMin);
        itinerary.expenses.min.total += rowMin.total;
        itinerary.expenses.max.total += rowMax.total;
      }

    };

    const addReservationsForAccomodations = (reservations: AccomodationReservation[]) => {
      const label = "Alloggi";
      const icon = ItineraryActivityTypeData.ACCOMODATION.icon;

      const rowMin = {
        label,
        icon,
        total: 0,
        items: []
      };

      const rowMax = {
        label,
        icon,
        total: 0,
        items: []
      };

      for (const reservation of reservations) {

        let min = Number.MAX_VALUE;
        let minProposal: AccomodationReservationProposal = null;
        let max = 0;
        let maxProposal: AccomodationReservationProposal = null;
        for (const proposal of reservation.proposals) {
          if (proposal.price < min) {
            min = proposal.price;
            minProposal = proposal;
          }
          if (proposal.price > max) {
            max = proposal.price;
            maxProposal = proposal;
          }
        }

        if (minProposal) {
          rowMin.total += minProposal.price;
          rowMin.items.push({
            label: null, //TODO
            value: minProposal.price
          });
        }
        if (maxProposal) {
          rowMax.total += maxProposal.price;
          rowMax.items.push({
            label: null, //TODO
            value: maxProposal.price
          });
        }

      }

      if (rowMin.total > 0 || rowMax.total > 0) {
        itinerary.expenses.max.items.push(rowMax);
        itinerary.expenses.min.items.push(rowMin);
        itinerary.expenses.min.total += rowMin.total;
        itinerary.expenses.max.total += rowMax.total;
      }
    };

    const addReservationsForActivities = (label: string, icon: string, activities: DayActivity[]) => {
      const rowMin = {
        label,
        icon,
        total: 0,
        items: []
      };

      const rowMax = {
        label,
        icon,
        total: 0,
        items: []
      };

      for (const activity of activities) {
        rowMin.total += activity.price;
        rowMin.items.push({
          label: null, //TODO
          value: activity.price
        });
        rowMax.total += activity.price;
        rowMax.items.push({
          label: null, //TODO
          value: activity.price
        });
      }

      if (rowMin.total > 0 || rowMax.total > 0) {
        itinerary.expenses.max.items.push(rowMax);
        itinerary.expenses.min.items.push(rowMin);
        itinerary.expenses.min.total += rowMin.total;
        itinerary.expenses.max.total += rowMax.total;
      }

    };

    // main

    let activities = [];
    for (const day of itinerary.days) {
      activities = activities.concat(day.activities);
    }

    addReservationsForTransportations("Voli", ItineraryActivityTypeData.FLIGHT.icon, itinerary.reservations.flights.concat(activities.filter((activity) => activity.type === ItineraryActivityType.FLIGHT && (!activity.reservationId))));

    for (const carTypeData of CarTypeData.values()) {
      const reservations = itinerary.reservations.cars.filter((reservation) => reservation.type === carTypeData.key).concat(activities.filter((activity) => activity.type && activity.type.toString() === carTypeData.key.toString() && (!activity.reservationId)));
      addReservationsForTransportations(carTypeData.label, carTypeData.icon, reservations);
    }

    addReservationsForTransportations("Treni", ItineraryActivityTypeData.TRAIN.icon, itinerary.reservations.trains.concat(activities.filter((activity) => activity.type === ItineraryActivityType.TRAIN && (!activity.reservationId))));
    addReservationsForTransportations("Navi", ItineraryActivityTypeData.FERRY.icon, itinerary.reservations.ferries.concat(activities.filter((activity) => activity.type === ItineraryActivityType.FERRY && (!activity.reservationId))));
    addReservationsForTransportations("Bus", ItineraryActivityTypeData.BUS.icon, itinerary.reservations.buses.concat(activities.filter((activity) => activity.type === ItineraryActivityType.BUS && (!activity.reservationId))));

    addReservationsForAccomodations(itinerary.reservations.accomodations.concat(
      activities
        .filter((activity) => activity.type === ItineraryActivityType.ACCOMODATION && (!activity.reservationId))
        .map((item) => ({ proposals: [item] } as AccomodationReservation))
    ));

    let typesData = ItineraryActivityTypeData.values()
      .filter((type) => type.key !== ItineraryActivityType.FLIGHT)
      .filter((type) => type.key !== ItineraryActivityType.TRAIN)
      .filter((type) => type.key !== ItineraryActivityType.FERRY)
      .filter((type) => type.key !== ItineraryActivityType.BUS)
      .filter((type) => type.key !== ItineraryActivityType.ACCOMODATION);

    for (const carTypeData of CarTypeData.values()) {
      typesData = typesData.filter((type) => type.key.toString() !== carTypeData.key.toString());
    }

    for (const type of typesData) {
      addReservationsForActivities(type.label, type.icon, activities.filter((activity) => activity.type === type.key));
    }

  }
}
